import * as io from 'io-ts';
import * as CommonTypes from '@shared/core/types/common';
import * as TypeConstants from '@shared/core/types/consts';

enum DISPLAY_ORDER_TYPE_DETAILS_MODE {
    'IGNORE' = 0,
    'FIRST_FIELD_ONLY' = 1,
    'ALL_FIELDS' = 2,
}

enum BUTTON_TYPE {
    'NEUTRAL' = 0,
    'CONFIRM' = 1,
    'DENY' = 2,
}

const displayOrderTypeDetailsModeEnum = CommonTypes.enumType('DISPLAY_ORDER_TYPE_DETAILS_MODE', DISPLAY_ORDER_TYPE_DETAILS_MODE);

const buttonType = CommonTypes.enumType('BUTTON_TYPE', BUTTON_TYPE);

const buttonDefinition: io.MixedObject<OLO.Config.LocationDetailsPage.Button> = {
    text: CommonTypes.validString,
    type: buttonType,
};

const postActionDetailsDefinition: io.MixedObject<OLO.Config.LocationDetailsPage.PostActionDetails> = {
    header: CommonTypes.arrayOfStrings,
    body: CommonTypes.arrayOfStrings,
};

const orderTypeDetailsModalDefinition: io.MixedObject<OLO.Config.LocationDetailsPage.OrderTypeDetailsModal> = {
    modalPreTitle: CommonTypes.validString,
    modalDescription: CommonTypes.arrayOfStrings,
    buttons: io.array(io.type(buttonDefinition)),
    isReadOnly: CommonTypes.boolean,
    displayOrderTypeDetailsMode: displayOrderTypeDetailsModeEnum,
    modalTitle: CommonTypes.nullable(CommonTypes.validString),
    modalIcon: CommonTypes.nullable(CommonTypes.validString),
    modalDescriptionAfterDataIsSet: CommonTypes.nullable(CommonTypes.arrayOfStrings),
    actionSuccess: CommonTypes.nullable(io.type(postActionDetailsDefinition)),
    actionFailure: CommonTypes.nullable(io.type(postActionDetailsDefinition)),
};

const locationDetailsFirstLoadIntroductionModalPageDefinition: io.MixedObject<OLO.Config.LocationDetailsPage.FirstLoadIntroductionModal> = {
    modalPreTitle: CommonTypes.validString,
    modalTitle: CommonTypes.validString,
    modalDescription: CommonTypes.arrayOfStrings,
    showCollectionTypeDropdown: CommonTypes.boolean,
};

export const rootDefinition: io.MixedObject<OLO.Config.LocationDetailsPage> = {
    orderTypeIds: TypeConstants.orderTypeIdsArray,
    showCategoriesOnInitInMobileView: CommonTypes.boolean,
    editableAmountProduct: CommonTypes.boolean,
    firstLoadIntroductionModal: CommonTypes.nullable(io.union([io.type(locationDetailsFirstLoadIntroductionModalPageDefinition), TypeConstants.defaultForEmptyOrderType])),
    orderTypeDetailsModal: CommonTypes.nullable(io.union([io.type(orderTypeDetailsModalDefinition), TypeConstants.defaultForEmptyOrderType])),
};

export const locationDetailsPageSchema = io.array(io.type(rootDefinition));
